// extracted by mini-css-extract-plugin
export var chatLink = "ChatLink-module--chatLink--1a6f5";
export var icon = "ChatLink-module--icon--52755";